import { array, boolean, object, string, InferType } from 'yup'

export const loadConfirmationStopSchema = object().shape({
  startTime: string().default('').nullable(),
  endTime: string().default('').nullable(),
  name: string().default('').nullable(),
  address: string().default('').nullable(),
  loadType: string().default('FTL').nullable(),
  loadCount: string().default('').nullable(),
  temperatureValue: string().default('').nullable(),
  hazmat: string().default('').nullable(),
  pickupNumber: string().default('').nullable(),
  weightValue: string().default('').nullable(),
  notes: string().default('').nullable(),
  contactName: string().default('').nullable(),
  contactPhone: string().default('').nullable(),
})

export const loadConfirmationFormSchema = object().shape({
  myCompanyName: string().default('').nullable(),
  myCompanyAddress: string().default('').nullable(),
  issuedBy: string().default('').nullable(),
  myCompanyEmail: string().email().default('').nullable(),
  myCompanyPhone: string().default('').nullable(),
  myCompanyCell: string().default('').nullable(),
  myCompanyAfterHoursPhone: string().default('').nullable(),
  invoicePodContactName: string().default('').nullable(),
  invoicePodEmail: string().email().default('').nullable(),
  invoicePodPhone: string().default('').nullable(),
  saveMyCompanyForFuture: boolean().default(true),

  carrierName: string().default('').nullable(),
  carrierAddress: string().default('').nullable(),
  dispatchName: string().default('').nullable(),
  dispatchEmail: string().email().default('').nullable(),
  dispatchPhone: string().default('').nullable(),
  dispatchCell: string().default('').nullable(),
  dispatchAfterHours: string().default('').nullable(),
  selectedCarrierCompanyId: string().default('').nullable(),

  currency: string().default('').nullable(),
  baseRate: string().default('').nullable(),
  detentionCharges: string().default('').nullable(),
  layoverCharges: string().default('').nullable(),
  fuelSurcharge: string().default('').nullable(),
  otherCharges: string().default('').nullable(),

  notes: string().default('').nullable(),
  saveNotesForFuture: boolean().default(true),

  pickups: array().of(loadConfirmationStopSchema).default([]),
  deliveries: array().of(loadConfirmationStopSchema).default([]),
})

export type LoadConfirmationFormValues = InferType<typeof loadConfirmationFormSchema>
export type LoadConfirmationStopFormValues = InferType<typeof loadConfirmationStopSchema>

export const emptyStop = (): LoadConfirmationStopFormValues =>
  loadConfirmationStopSchema.cast({}) as LoadConfirmationStopFormValues

export const defaultLoadConfirmationFormValues: LoadConfirmationFormValues =
  loadConfirmationFormSchema.cast({
    pickups: [emptyStop()],
    deliveries: [emptyStop()],
  }) as LoadConfirmationFormValues
